import { useEffect, useRef } from 'react';
import { CompletedStop } from 'woundscribe/types';

/**
 * Calls onMaxDurationStop once for each new 75-minute stop. The value present at
 * mount belongs to an earlier stop and is ignored. Manual stops are ignored too,
 * because the Confirm Stop handler navigates for those.
 */
export function useMaxDurationStopNavigation(
  lastCompletedStop: CompletedStop | null,
  onMaxDurationStop: () => void
): void {
  const handledStopRef = useRef(lastCompletedStop);
  const onMaxDurationStopRef = useRef(onMaxDurationStop);
  onMaxDurationStopRef.current = onMaxDurationStop;

  useEffect(() => {
    if (lastCompletedStop === handledStopRef.current) {
      return;
    }
    handledStopRef.current = lastCompletedStop;
    if (lastCompletedStop?.reason === 'max_duration') {
      onMaxDurationStopRef.current();
    }
  }, [lastCompletedStop]);
}
